import { render, staticRenderFns } from "./DNSListModal.vue?vue&type=template&id=83680604&scoped=true&"
import script from "./DNSListModal.vue?vue&type=script&lang=js&"
export * from "./DNSListModal.vue?vue&type=script&lang=js&"
import style0 from "./DNSListModal.vue?vue&type=style&index=0&id=83680604&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83680604",
  null
  
)

export default component.exports